export const PRICING_DATA = {
  monthly_plans: [
    {
      id: "starter",
      name: "STARTER",
      price: "₹149",
      billing_cycle: "/ month",
      target_audience: "Food Trucks, Tea Stalls (Tapris), Tiny Bakeries",
      is_popular: false,
      features: [
        { text: "Up to 50 Menu Items", included: true },
        { text: "Up to 10 QR Codes (Tables)", included: true },
        { text: "1 Location Supported", included: true },
        { text: "Order Management Dashboard", included: true },
        { text: "Basic Custom Logo Upload", included: true },
        { text: "Email Only Support", included: true },
        { text: "Analytics Dashboard", included: false },
        { text: "Promo Codes", included: false },
        { text: "Chef's Picks / Upsell Billboard", included: false },
        { text: "WhatsApp Receipts", included: false }
      ],
      cta_text: "Get Started"
    },
    {
      id: "growth",
      name: "GROWTH",
      price: "₹249",
      billing_cycle: "/ month",
      target_audience: "Standard Cafes, QSRs, Small Dine-ins",
      is_popular: false,
      features: [
        { text: "Up to 150 Menu Items", included: true },
        { text: "Up to 25 QR Codes (Tables)", included: true },
        { text: "1 Location Supported", included: true },
        { text: "Order Management Dashboard", included: true },
        { text: "Full Theme & Logo Control", included: true },
        { text: "Standard Chat Support", included: true },
        { text: "Basic Analytics (Today's Stats)", included: true },
        { text: "Up to 3 Active Promo Codes", included: true },
        { text: "Chef's Picks (High-Margin Upsell)", included: true },
        { text: "WhatsApp Receipts", included: false }
      ],
      cta_text: "Choose Growth"
    },
    {
      id: "pro",
      name: "PRO",
      price: "₹449",
      billing_cycle: "/ month",
      target_audience: "Busy Dine-in Restaurants, Fine Dining, Lounges",
      is_popular: true,
      features: [
        { text: "Up to 300 Menu Items", included: true },
        { text: "Up to 60 QR Codes (Tables)", included: true },
        { text: "1 Location Supported", included: true },
        { text: "Order Management Dashboard", included: true },
        { text: "Full Theme & Logo Control", included: true },
        { text: "Priority Call Support", included: true },
        { text: "Deep Historical Trends & Data Export", included: true },
        { text: "Unlimited Promo Codes", included: true },
        { text: "Chef's Picks", included: true },
        { text: "Manual WhatsApp Receipts (Click-to-Chat)", included: true }
      ],
      cta_text: "Choose Pro"
    },
    {
      id: "enterprise",
      name: "ENTERPRISE",
      price: "₹899+",
      billing_cycle: "/ month",
      target_audience: "High-Volume, Multi-Outlet Brands, Franchises",
      is_popular: false,
      features: [
        { text: "1,000+ Menu Items (Flexible)", included: true },
        { text: "Unlimited QR Codes (Per Outlet)", included: true },
        { text: "Multi-Location / Chain Management", included: true },
        { text: "Order Management Dashboard", included: true },
        { text: "Advanced / White-Label Branding", included: true },
        { text: "Dedicated Account Manager", included: true },
        { text: "Full Chain Analytics & Insights", included: true },
        { text: "Unlimited Promo Codes", included: true },
        { text: "Chef's Picks", included: true },
        { text: "FULLY AUTOMATED WhatsApp API Receipts", included: true }
      ],
      cta_text: "Contact Sales"
    }
  ],
  accelerator_packages: [
    {
      id: "pro_3_month",
      name: "PRO 3-Month Accelerator",
      offer_tagline: "Save up to 10% instantly!",
      upfront_price: "₹1,245",
      effective_monthly: "₹415 / mo",
      savings_text: "Save ₹102 Instantly",
      base_features_of: "Pro Plan",
      cta_text: "Lock in Pro Savings"
    },
    {
      id: "enterprise_3_month",
      name: "ENTERPRISE 3-Month Accelerator",
      offer_tagline: "Save up to 10% instantly!",
      upfront_price: "₹2,495",
      effective_monthly: "₹831 / mo",
      savings_text: "Save ₹202 Instantly",
      base_features_of: "Enterprise Plan",
      cta_text: "Lock in Enterprise Savings"
    },
    {
      id: "pro_6_month",
      name: "PRO 6-Month Accelerator",
      offer_tagline: "Pay for 5 months, Get the 6th Month FREE!",
      upfront_price: "₹2,245",
      effective_monthly: "₹374 / mo",
      savings_text: "Save ₹449 Instantly",
      base_features_of: "Pro Plan",
      cta_text: "Lock in Pro Savings"
    },
    {
      id: "enterprise_6_month",
      name: "ENTERPRISE 6-Month Accelerator",
      offer_tagline: "Pay for 5 months, Get the 6th Month FREE!",
      upfront_price: "₹4,495",
      effective_monthly: "₹749 / mo",
      savings_text: "Save ₹899 Instantly",
      base_features_of: "Enterprise Plan",
      cta_text: "Lock in Enterprise Savings"
    }
  ]
};
